/**
 * Which API this page should call.
 *
 * One admin image is served on every apex (heylifeapp.de, the sslip.io testing host,
 * heylife.heychurch.de). VITE_API_URL is baked for BASE_DOMAIN only. Using that host
 * from another apex is cross-site: the session cookie is not sent, and the API
 * rejects the preflight. Each apex already proxies api.<host>.
 */
export function resolveApiUrl(opts: {
  dev: boolean;
  baked: string | undefined;
  hostname: string | undefined;
}): string {
  if (opts.dev) return opts.baked || "http://localhost:3000";
  const host = opts.hostname;
  if (host && host !== "localhost" && host !== "127.0.0.1") return `https://api.${host}`;
  return opts.baked || "";
}
